/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-comment-textnodes */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import { Avatar } from '@mui/material';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import SettingsIcon from '@mui/icons-material/Settings';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ChatIconButton from './ChatIconButton';
import FlagIssueButton from './FlagIssueButton';
import { Dropdown, ButtonGroup, Spinner } from 'react-bootstrap';
import toast from 'react-hot-toast';
import { routers } from 'router/router';
import { useHistory } from 'react-router';
import { useLocation } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { 
  getUserId, 
  getAccessToken, 
  //removeAccessToken, removeUserId 
} from 'utils/sessionStorage';
import basicInformationServices from 'services/basicInformationApi';
import { FileToBase64 } from 'components/helper/helper';
import { STRIPE_PRICE_NAME, USER_ROLE } from 'constants/common';
import { catName } from 'components/helper/helper';
import { getCurrentBasicDetail, getStripeSubscription, getStripeSubscriptionInfo, logout } from 'app/basicInformationSlice/basicInformationSlice';
import { getStudent } from 'app/authorization/authorizationSlice';
import PaymentServices from 'services/payment';

export const CalcTrialDays = (subcription:any) => {
  if (subcription) {
    let trial_end  =  new Date(subcription.trial_end * 1000);
    let d = trial_end.getTime() - new Date().getTime();
    return Math.round (d / (1000 * 3600 * 24)); 
  }
  return 0;
}

export const renderTrialMessage = (subcription:any) => {
  let d = CalcTrialDays(subcription);
  if (d === 1) {
    return ` ${d} day until your trial is up. `;
  }
  else {
    return ` ${d} days until your trial is up. `;
  }
}

interface Props {
  title: string;
}
const Header = (props: Props) => {
  const dispatch:any = useAppDispatch();
  let history:any = useHistory();
  const [profilePicture, setProfilePicture] = useState<any>();
  const [profileDescript, setprofileDescript] = useState('');
  const personalStore = useAppSelector((store) => store.basicInformation.myBasicInformation);
  const currentStudentId = useAppSelector((store) => store.basicInformation.currentStudentId);
  const myStripeSubscription = useAppSelector((store) => store.basicInformation.myStripeSubscription);
  const subscriptInfo = useAppSelector((store) => store.basicInformation.stripeSubscriptionInfo);
  const [displayName, setDisplayName] = useState('');
  const [stripeSubscription, setStripeSubscription] = useState<any>(null);
  const [paymentPlan, setPaymentPlan] = useState<any>(null);
  const [studentStripeSubscription, setStudentStripeSubscription] = useState<any>(null);
  const [studentSubscriptionInfo, setStudentSubscriptionInfo] = useState<any>(null);
  const [isTrialing, setIsTrialing] = React.useState(false);
  const fakeStudentId = `25${personalStore?.student_id ?? '00'}`;
  const role  = personalStore?.user_role ?? '';

  React.useEffect(() => {
    const profilePictureName = personalStore?.profile_picture_file_name ?? null;
    const userRole: string = (personalStore?.user_role ?? '').toLowerCase()?.trim();
    if (profilePictureName) {
      basicInformationServices.getProfilePicture(profilePictureName).then(async (res) => {
        const blob = new Blob([res], { type: 'image/png;charset=utf-8' });
        const url = await FileToBase64(blob);
        setProfilePicture(url);
      });
    }

    if (userRole) {
      sessionStorage.setItem('userRole', role);
      setprofileDescript(userRole);
      if (userRole === USER_ROLE.student.toLowerCase()) {
        let s =
          personalStore && personalStore?.year_finish_high_school
            ? `Class of ${personalStore?.year_finish_high_school}`
            : '';
        setprofileDescript(s);
      } else if (userRole === USER_ROLE.counselor.toLowerCase()) {
        setprofileDescript('Counselor');
      } else {
        setprofileDescript(`Role: ${userRole}.`);
      }
    }
    setDisplayName(
      catName(personalStore?.first_name, personalStore?.middle_name, personalStore?.last_name)
    );
  }, [personalStore?.first_name, personalStore?.last_name, personalStore?.middle_name]);

  const handleLogout = (showMsg:boolean) => {
    dispatch(logout());
    if (showMsg) {
      toast.success("You have been successfully logged out!");
    }
    history.push(routers.login.path);
  };
  
  const getPlanName = (ret:any)=>{
    if (ret && ret.subcription_plan) {
        switch (ret.subcription_plan) {
          case STRIPE_PRICE_NAME.GradMapStarter:
            return "GradMap Starter";
          case STRIPE_PRICE_NAME.SilverMonth:
            return "Silver Monthly";
          case STRIPE_PRICE_NAME.SilverYear:
            return "Silver Monthly";
          case STRIPE_PRICE_NAME.GoldMonth:
            return "Gold Monthly";
          case STRIPE_PRICE_NAME.GoldYear:
            return "Gold Year";
          case STRIPE_PRICE_NAME.SilverPlusMonth:
            return "Silver Plus Monthly";
          case STRIPE_PRICE_NAME.SilverPlusYear:
            return "Silver Plus Monthly";
          default:
            return ''; //not applicable, not available
        }
    }
    return '';
  }

  async function getUserBillPortalUrl() {
    let returnUrl = `${window.location.origin}/#/settings?active-tab=5`;       
    let billUrl: any = await PaymentServices.getUserBillPortalUrl(returnUrl, personalStore.student_id);
    return billUrl;
  }

  async function getStudentBillPortalUrl(studentId: any) {
    if (!Number.isNaN(studentId)) {
      let returnUrl = `${window.location.origin}/#/application/counselor/${studentId}`;       
      let billUrl: any = await PaymentServices.getUserBillPortalUrl(returnUrl, studentId);
      return billUrl;
    }
    else{
      return '';
    }
  }

  const onClickUpgradeLink = async() => {
    if (paymentPlan?.subcription_plan === STRIPE_PRICE_NAME.GradMapStarter) {
      history.push(routers.upgradePlan.path);
      return;
    }

    let billUrl:any = await getUserBillPortalUrl();
    if (billUrl) {
      window.location.href = `${billUrl}`;
    }
  }

  const onClickStudentUpgradeLink = async() => {
    let billUrl:any = await getStudentBillPortalUrl(currentStudentId);
    if (billUrl) {
      window.location.href = `${billUrl}`;
    }
  } 

  async function getData() {
    let id = getUserId();
    let token = getAccessToken();
    try {
      if (token && id) {
        if (personalStore?.status !== 'loading') {
          try {
            await dispatch(getStudent(id)).unwrap();
            await dispatch(getCurrentBasicDetail(id)).unwrap();
            let ss:any = await basicInformationServices.getStripeSubscription(id);
            setStripeSubscription(ss);
           
            if (!subscriptInfo) {
              let ssInfo = await dispatch(getStripeSubscriptionInfo(id)).unwrap();
              setPaymentPlan(ssInfo);
            } else {
              setPaymentPlan(subscriptInfo);
            }
          }
          catch(ex){
            // Backend will handle invalid tokens, no need to auto logout
            console.error('Error loading data:', ex);
          }
        }
      }
      // If no token/userId, just skip - backend will handle authentication
    }
    catch(ex){
      console.error('Error in getData:', ex);      
    }
  }

  // Sync từ Redux store khi có data
  React.useEffect(() => {
    if (myStripeSubscription) { 
      setStripeSubscription(myStripeSubscription);
    }
  }, [myStripeSubscription]);

  React.useEffect(() => {
    if (subscriptInfo) {
      getData();
      setPaymentPlan(subscriptInfo);
      console.log('subscriptInfo:', subscriptInfo);
      if (subscriptInfo?.subcription_status === 'trialing') {
        setIsTrialing(true);
      }
    }
  }, [subscriptInfo]);

  React.useEffect(() => {
    if (role === USER_ROLE.student && personalStore?.student_id) {
      const id = getUserId();
      // Chỉ gọi nếu chưa có data hoặc student_id khác
      if ((!myStripeSubscription || !subscriptInfo) && id === personalStore.student_id) {
        getData();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [personalStore?.student_id, role]);

  const updateStudentInfo = async () => {
    if (role === USER_ROLE.parent && currentStudentId) {
      try {
        let ss:any=  await dispatch(getStripeSubscription(currentStudentId)).unwrap();
        setStudentStripeSubscription(ss);
        // Avoid writing child's Stripe status into global Redux (parent has no own subscription)
        const ssInfo = await basicInformationServices.getEnableExtention(currentStudentId);
        setStudentSubscriptionInfo(ssInfo);
      } catch(ex) {
        console.error('Error updating student info:', ex);
      }
    }
  }

  React.useEffect(() => {
    if (role === USER_ROLE.parent && currentStudentId) {
      updateStudentInfo();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentStudentId, role]);


  return (
    <div className="gm-topbar">
      <div className="w-100 d-flex gm-topbar-height justify-content-space">
        <div className="d-flex gm-topbar-height">
          <img
            src={'/assets/images/logo-color.svg'}
            alt="GradMap logo"
            style={{ alignSelf: 'center' }}
            height={48}
            className="d-inline mx-3 pl-3 pointer"
            onClick={() =>
              history.push({
                pathname: routers.dashBoard.path,
                search: `?role=${role}`,
              })
            }
          />
          <div className="d-inline border-end" style={{ width: '1px' }}></div>
          <div className="d-flex text-field-light h4 text-center pl-3" style={{ fontWeight: 600, alignSelf: 'center', margin: '8px' }}>
              {props.title}
          </div>
        </div>

        <div className="d-flex">
          {isTrialing && (
            <div className="d-flex text-danger text-center pl-3 align-self-center " style={{margin:'8px'}} >
              {`${renderTrialMessage(stripeSubscription)}`}
              {/* {!location.pathname.includes('/payment') && (
                <>
                &nbsp;<a href="/#/payment">Click here to subscribe!</a>
                </>
              )} */}
            </div>
          )}
        </div>

        <div className="d-flex justify-content-end align-items-center">
          {/* Flag an Issue (WORKFLOW-001) */}
          {(role === USER_ROLE.student || role === USER_ROLE.counselor || role === USER_ROLE.parent) && (
            <FlagIssueButton />
          )}
          {/* Chat Icon Button - Facebook style */}
          {(role === USER_ROLE.student || role === USER_ROLE.counselor || role === USER_ROLE.parent) && (
            <ChatIconButton />
          )}
          {personalStore?.user_role === USER_ROLE.student && (
            <>
            { paymentPlan ? (
            <span className="mx-3 text-left" style={{padding:'6px'}}>
              <span className="txt-info">Plan: {getPlanName(paymentPlan)}</span>
                  <span className="txt-info">. </span>
                  <span className="txt-info text-primary" style={{textDecoration: 'underline', cursor: 'pointer'}} onClick={onClickUpgradeLink} title='Upgrade Subcription Plan'>Upgrade </span>
              <br/><div className="txt-info text-field-light">GM ID: {fakeStudentId}</div>
            </span>
            ):(
              <span className="txt-info d-inline-flex align-items-center" role="status" aria-live="polite" aria-busy="true" style={{padding:'6px'}}>
                <Spinner animation="border" size="sm" className="me-1" />
                Checking plan...
              </span>
            )}
            </>
          )}
          {personalStore?.user_role === USER_ROLE.parent 
            && window.location.hash.includes('#/application/counselor/') && currentStudentId && (
            <>
            { studentStripeSubscription && studentSubscriptionInfo ?  (
            <span className="mx-3 text-left" style={{padding:'6px'}}>
            <span className="txt-info">Plan: {getPlanName(studentSubscriptionInfo)}</span>
                <span className="txt-info">. </span>
                <span className="txt-info text-primary" style={{textDecoration: 'underline', cursor: 'pointer'}} onClick={onClickStudentUpgradeLink} title='Upgrade Subcription Plan'>Upgrade </span>
            <br/><div className="txt-info text-field-light">Student GM ID: 25{studentStripeSubscription?.student_id ?? '00'} </div>
            </span>
            ):(
              <>
              <span className="txt-info d-inline-flex align-items-center" role="status" aria-live="polite" aria-busy="true" style={{padding:'6px'}}>
                <Spinner animation="border" size="sm" className="me-1" />
                Checking plan...
              </span>
              </>
            )}
            </>
          )}

          <span>
            <Avatar
              className="me-md-1"
              alt="sb-avatar"
              src={profilePicture}
              sx={{ width: 40, height: 40 }}
            />
          </span>
          <span>
            <Dropdown as={ButtonGroup} size="sm">
              <Dropdown.Toggle variant="white" id="dropdown-split-basic">
                <div className="d-flex">
                  <div className="text-start text-left">
                    {/* {displayEmail} */}
                    <span>{displayName}</span>
                    <div className="text-field-light">{profileDescript}</div>
                  </div>
                  <div className="icon-arrowdown">
                    <ArrowDropDownIcon sx={{ color: '#231F20' }}></ArrowDropDownIcon>
                  </div>
                  <div className="icon-arrowup">
                    <ArrowDropUpIcon sx={{ color: '#231F20' }}></ArrowDropUpIcon>
                  </div>
                </div>
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item onClick={() => history.push(routers.settings.path)}>
                  <SettingsIcon fontSize="small" className="mx-1" />
                  Settings
                </Dropdown.Item>
                <Dropdown.Item onClick={() => handleLogout(true)}>
                  <PowerSettingsNewIcon fontSize="small" className="mx-1" />
                  Logout
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </span>
        </div>
      </div>
      <style scoped>{`
      .dropdown-toggle::after {
        display: none !important;
      }
      .txt-info {
        font-size: 0.765625rem;
      }
      `}</style>
    </div>
  );
};

export default Header;
